import Swiper from './../imports/import-swiper';
import { gsap } from "gsap";
import { bindCursorHoverEffect } from './cursor.js';
export default ()=>{
    const scrolledWrapper = document.querySelector('.scrolled-slider__wrapper');
    const scrolledContainer = document.querySelector('.scrolled-slider__container');
    const wrapper = document.querySelector('.experience-section--scrolled');
    const container = document.querySelector('.experience-slider--scrolled');
    if (container) {
        const sliders = container.querySelectorAll('.swiper-slide');
        runSliderSwipe();
    }

    function runSliderSwipe(){
        const journalSlider = new Swiper(container, {
            effect: 'slide',
            allowTouchMove: true,
            slidesPerView: 3,
            watchSlidesProgress:true,
            breakpoints: {
              900: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              448: {
                slidesPerView: 1,
                spaceBetween: 14,
              }
            },
            on: {
              slideChange: () => {
                bindCursorHoverEffect()
              }
            }
        });

        sliders.forEach(slider =>{
            const text = slider.querySelector('p');
            const hiddenP = slider.querySelector('.hidden-p')
            const hiddenPHeight = hiddenP.offsetHeight;
            hiddenP.style.height = 0;
            slider.addEventListener('mouseover', ()=>{
              if (!document.documentElement.classList.contains('touch')) {
                gsap.to(hiddenP, {
                  height: hiddenPHeight
                })
                gsap.to(text, {
                  y: 0,
                  duration:0.5,
                })
              }
            })
            slider.addEventListener('mouseout', ()=>{
              if (!document.documentElement.classList.contains('touch')) {
                gsap.to(hiddenP, {
                    height: 0
                })
                gsap.to(text, {
                    y: 150,
                    duration:0.5,
                })
              }
            })
        })

        if (!document.documentElement.classList.contains('touch')) {

            const currentWrapperHeight = scrolledWrapper.offsetHeight;
            const scrollStep = 400;
            const extraSlidesCounter = sliders.length - journalSlider.params.slidesPerView + 1;
            const extraHeight = scrollStep * extraSlidesCounter;
            scrolledWrapper.style.height = currentWrapperHeight + extraHeight + 'px';

            const startScroll = window.pageYOffset + scrolledWrapper.getBoundingClientRect().top + scrolledContainer.firstElementChild.offsetHeight - (document.querySelector('.sticky_header').offsetHeight + 100);
            const scrollSteps = [];
            for (let i = 0; i < extraSlidesCounter; i++) {
              const prevNum = scrollSteps == 0 ? startScroll : scrollSteps[scrollSteps.length - 1];
              scrollSteps.push(prevNum + scrollStep)
            }

            let prevScroll = 0;
            window.addEventListener('scroll', () => {
              const topAnchor = scrolledWrapper.getBoundingClientRect().top + scrolledContainer.firstElementChild.offsetHeight;
              const bottomAnchor = scrolledWrapper.getBoundingClientRect().bottom - scrolledContainer.lastElementChild.offsetHeight;
              const topOffset = document.querySelector('.sticky_header').offsetHeight + 100;
              const bottomOffset = topOffset + container.offsetHeight;
              const currScroll = window.pageYOffset;

              if (topAnchor < topOffset && bottomAnchor > bottomOffset) {
                const scrolledTop = scrolledContainer.getBoundingClientRect().top;
                scrolledContainer.style.position = 'fixed';
                scrolledContainer.style.top = scrolledTop + 'px';
                scrolledContainer.style.left = '0';
                scrolledContainer.style.width = '100%';
                for (let i = 0; i < scrollSteps.length; i++) {
                  if (currScroll > prevScroll && currScroll > scrollSteps[i] && currScroll < scrollSteps[i+1]) {
                    journalSlider.slideTo(i+1)
                  } else if (currScroll < prevScroll && currScroll < scrollSteps[i] && currScroll > scrollSteps[i-1]) {
                    journalSlider.slideTo(i-1)
                  }
                }
              } else {
                scrolledContainer.style.position = 'absolute';
                scrolledContainer.style.left = '0';
                scrolledContainer.style.width = '100%';
                if (topAnchor >= topOffset) {
                  scrolledContainer.style.top = '0';
                }
                if (bottomAnchor <= bottomOffset) {
                  scrolledContainer.style.top = extraHeight + 'px';
                }
              }

              prevScroll = currScroll;
            })

        }
    }
}
